import {Component, ChangeDetectionStrategy, Input} from '@angular/core';
import {Operand} from '@em/shared/mapping-engine/domain-models';

@Component({
  selector: 'em-operand-label',
  templateUrl: './operand-label.component.html',
  styleUrls: ['./operand-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmOperandLabelComponent {
  @Input() operand: Operand | undefined;
}
